<template>
  <div>
    <div class="row top">
      <div class="row">
        <div class="col-md-2">
          <back-button returnUrl="/attendances"></back-button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h4><u>Αναλυτική λίστα παρουσιών</u></h4>
        </div>
      </div>
      <div class="col-md-1" style>
        <DxLoadIndicator
          id="image-indicator"
          :height="40"
          :width="40"
          :visible="loadIndicatorVisible"
        />
      </div>
    </div>

    <!-- Φίλτρα -->
    <div class="row">
      <div class="col-md-8">
        Δομές
        <DxSelectBox
          :search-enabled="true"
          :data-source="structures"
          search-mode="contains"
          search-expr="Description"
          :search-timeout="200"
          :min-search-length="2"
          :show-data-before-search="true"
          display-expr="Description"
          value-expr="Id"
          v-model="selectedStructureId"
          @value-changed="setSelectedStructure"
          placeholder="Επιλέξτε Δομή"
          :show-clear-button="true"
        />
      </div>
      <div class="col-md-2">
        Ημερομηνία
        <DxDateBox
          :value="date"
          picker-type="calendar"
          display-format="dd/MM/yyyy"
          @value-changed="setSelectedDate"
          :disabled-dates="disabledDates"
          :max="maxDate"
        />
      </div>
      <div class="col-md-2">
        <br />
        <DxButton2
          class="col-md-5"
          name="generateTemporaryPrintLink"
          icon="link"
          hint="Δημιουργία Προσωρινού Συνδέσμου Εκτύπωσης Παρουσιών"
          style="text-align: center"
          :on-click="generateTempPrintLink"
        />
        <div v-if="showLock == true">
          <DxButton2
            class="col-md-5 pull-right"
            name="btnUnlockAttendance"
            icon="glyphicon glyphicon-lock"
            style="text-align: center"
            :on-click="onUnlockAttendance"
            v-if="AttendanceIsLocked && !masterUnLockDisabled"
          />
          <DxButton2
            id="edit"
            class="col-md-5 pull-right"
            icon="edit"
            v-if="!AttendanceIsLocked"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 grid-pad">
        <DxDataGrid
          :data-source="attendanceRecords"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :column-auto-width="true"
          :show-borders="true"
          key-expr="Id"
          :show-row-lines="true"
          :row-alternation-enabled="true"
          @row-prepared="onRowPrepared"
          @row-updating="onRowUpdating"
          :ref="dataGridRefKey"
          @editor-preparing="onEditorPreparing"
          @row-validating="onRowValidating"
        >
          <DxPaging :page-size="20" :enabled="false" />
          <DxEditing :allow-updating="true" :use-icons="true" mode="cell" />
          <DxHeaderFilter :visible="true" />
          <DxFilterRow :visible="true" />
          <DxSearchPanel :visible="true" />

          <!--  <DxColumn  caption="Κωδικός" data-field="Id" data-type="integer" :visible="false">                    
                </DxColumn> -->

          <DxColumn
            caption="Κατηγορία"
            :allow-editing="false"
            data-field="ContractDto.ContractCategoryDto.FullDescription"
            data-type="string"
            :visible="true"
            width="250px"
            :group-index="0"
            alignment="center"
            left="30px;"
          >
          </DxColumn>

          <DxColumn
            caption="Ωφελούμενη/ος"
            width="280px"
            :allow-editing="false"
            data-field="ContractDto.ParentDto.FullName"
            data-type="string"
            :visible="true"
            alignment="left"
          >
          </DxColumn>

          <DxColumn
            caption="Εξυπηρετούμενο Άτομο"
            width="280px"
            :allow-editing="false"
            data-field="ContractDto.KidDto.KidFullName"
            data-type="string"
            :visible="true"
            alignment="left"
          >
          </DxColumn>

          <DxColumn
            caption="Είσοδος"
            data-field="HasAttended"
            data-type="boolean"
            width="100px"
            :visible="true"
            alignment="center"
          >
          </DxColumn>

          <DxColumn
            caption="Ώρα Εισόδου"
            data-field="DisplayStartTime"
            data-type="datetime"
            width="90px"
            :visible="true"
            alignment="center"
            :editorOptions="timeSettings"
            format="HH:mm"
          >
          </DxColumn>

          <DxColumn
            caption="Έξοδος"
            data-field="HasExited"
            data-type="boolean"
            width="100px"
            :visible="true"
            alignment="center"
          >
          </DxColumn>

          <DxColumn
            caption="Ώρα Εξόδου"
            data-field="DisplayEndTime"
            data-type="datetime"
            width="80px"
            :visible="true"
            alignment="center"
            :editorOptions="timeSettings"
            format="HH:mm"
          >
          </DxColumn>

          <DxColumn
            caption="Κινητό"
            data-field="FromMobile"
            data-type="boolean"
            width="80px"
            :visible="false"
            alignment="center"
            :allow-editing="false"
          >
          </DxColumn>

          <DxColumn
            caption="Επιβεβαιωμένη"
            data-field="IsValid"
            data-type="boolean"
            width="100px"
            :visible="true"
            alignment="center"
            :allow-editing="false"
          >
          </DxColumn>

          <DxColumn type="buttons" width="50px">
            <GridButton
              name="btnUnlockAttendanceRecord"
              hint="Ξεκλείδωμα εγγραφής"
              :visible="showRecordLock"
              icon="glyphicon glyphicon-lock"
              :on-click="onUnlockAttendanceRecord"
            />
            <GridButton
              name="btnEditAttendanceRecord"
              hint="Εγγραφή σε επεξεργασία"
              :visible="attendanceRecordIsUnLocked"
              icon="edit"
            />
          </DxColumn>
        </DxDataGrid>
      </div>
    </div>

    <DxPopup
      :visible="unlockPopupIsVisible"
      :drag-enabled="false"
      :close-on-outside-click="false"
      :show-title="true"
      :show-close-button="false"
      :width="500"
      :height="300"
      title="Επιλέξτε λόγο ξεκλειδώματος"
    >
      <div class="row">
        <DxLookup2
          :data-source="unlockReasons"
          value-expr="Id"
          display-expr="Description"
          placeholder="Λόγος ξεκλειδώματος"
          v-model="selectedUnlockReasonId"
        >
          <DxDropDownOptions :shading="false" :full-screen="false" />
        </DxLookup2>
      </div>
      <div class="row" style="padding-top: 20px">
        <textarea
          v-model="selectedUnlockRasonDescription"
          placeholder="Περιγραφή"
          rows="5"
          cols="50"
          style="width: 100%"
        />
      </div>
      <div class="row" style="padding-top: 20px">
        <DxButton2
          text="Αποθήκευση"
          type="success"
          styling-mode="contained"
          @click="onSaveFromPopup"
          :disabled="
            this.selectedUnlockReasonId == null ||
            this.selectedUnlockReasonId == 0
          "
        />
        <DxButton2
          text="Επιστροφή"
          type="danger"
          styling-mode="contained"
          @click="onClosePopup"
        />
      </div>
    </DxPopup>
    <DxPopup
      :visible="showTempLinkPopup"
      :drag-enabled="false"
      :close-on-outside-click="false"
      :show-title="true"
      :show-close-button="true"
      :width="800"
      :height="300"
      @hiding="onHiding"
      title="Προσωρινός Σύνδεσμος Εκτύπωσης Παρουσιών"
    >
      <div class="dx-field">
        <div class="dx-field-label">Προσωρινός Σύνδεσμος Εκτύπωσης</div>
        <div class="dx-field-value">
          <DxTextArea :height="150" :value="this.tempLink" />
        </div>
      </div>
      <DxButton2
        class="pull-right"
        text="Αντιγραφή Συνδέσμου"
        icon="copy"
        styling-mode="contained"
        @click="onCopyToClipboard"
      />
    </DxPopup>
  </div>
</template>

<script>
import mainService from "../../services/mainService";
import BackButton from "../../components/shared/backButton";
import { DxSelectBox } from "devextreme-vue/select-box";
import DxDateBox from "devextreme-vue/date-box";
import { DxButton as DxButton2 } from "devextreme-vue/button";
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxSearchPanel,
  DxLookup,
  DxButton as GridButton,
} from "devextreme-vue/data-grid";
import notify from "devextreme/ui/notify";
import {
  DxDropDownOptions,
  DxLookup as DxLookup2,
} from "devextreme-vue/lookup";
import { DxPopup } from "devextreme-vue/popup";
import DxTextArea from "devextreme-vue/text-area";
import DxTextBox from "devextreme-vue/text-box";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";

export default {
  props: ["sId", "dDate"],
  components: {
    BackButton,
    DxSelectBox,
    DxDateBox,
    DxButton2,
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxSearchPanel,
    //DxLookup,
    GridButton,
    DxPopup,
    DxDropDownOptions,
    DxLookup2,
    DxLoadIndicator,
    DxTextArea,
  },
  data() {
    return {
      dataGridRefKey: "attendancesDataGrid",
      date: this.$moment().format("MM/DD/YYYY"),
      maxDate: this.$moment().format("MM/DD/YYYY"),
      structures: [],
      AttendanceStartTime: "",
      AttendanceEndTime: "",
      attendanceRecords: [],
      absenseReasons: [],
      unlockReasons: [],
      selectedStructureId: 0,
      unlockPopupIsVisible: false,
      selectedAttendanceId: 0,
      selectedAttendanceRecordId: 0,
      selectedUnlockReasonId: 0,
      selectedUnlockRasonDescription: "",
      AttendanceIsLocked: true,
      remainingMinutesToLock: 0, //min
      unlockDuration: 0,
      attendanceRecordTimer: null,
      disabledDates: [],
      loadIndicatorVisible: false,
      showLock: false,
      timeSettings: { type: "time", displayFormat: "HH:mm" },
      showTempLinkPopup: false,
      tempLink: "",
      masterUnLockDisabled: false,
    };
  },
  computed: {
    organizationId() {
      return this.$store.getters.getSelectedOrganizationId;
    },
    hasFullAccess() {
      return this.$store.getters.getHasFullAccess;
    },
    dataGrid: function () {
      return this.$refs[this.dataGridRefKey].instance;
    },
  },
  watch: {
    organizationId: async function (newValue, oldValue) {
      const res = await mainService.get(
        `/structures/GetStructuresByUserAndOrganization?organizationId=${this.organizationId}`
      );
      this.structures = res.data;
      if (this.structures.length > 0) {
        this.selectedStructureId = this.structures[0].Id;
        if (this.hasFullAccess) {
          await this.getAttendanceRecords();
        } else this.attendanceRecords = [];
      } else this.attendanceRecords = [];
    },
  },
  methods: {
    onRowPrepared(e) {
      if (
        e.rowType == "data" &&
        e.data.DisplayStartTime == e.data.DisplayStartTimeMobile &&
        e.data.DisplayStartTime != "0001-01-01T00:00:00"
      ) {
        e.rowElement[0].cells[3].style.backgroundColor = "#a2d4ab";
        e.rowElement[0].cells[4].style.backgroundColor = "#a2d4ab";
      }

      if (
        e.rowType == "data" &&
        e.data.DisplayEndTime == e.data.DisplayEndTimeMobile &&
        e.data.DisplayEndTime != "0001-01-01T00:00:00"
      ) {
        e.rowElement[0].cells[5].style.backgroundColor = "#a2d4ab";
        e.rowElement[0].cells[6].style.backgroundColor = "#a2d4ab";
      }

      // e.rowElement.style.backgroundColor = "#a2d4ab"; //"#059862"; //"#28a745";
      // e.rowElement.style.color = "black";
      // e.rowElement.className = e.rowElement.className.replace(
      //   "dx-row-alt",
      //   ""
      // );

      //if we want to show mobile icon at the left side of attendanceRecords index uncomment and edit below lines
      // if (e.rowType == "data" && e.data.FromMobile == true) {
      //   e.cells[0].cellElement.innerHTML =
      //     '<label class="dx-icon glyphicon glyphicon-phone dx-link-icon" style="color:#337ab7; font-size: 18px;" title="Ενημερώθηκε από το κινητό"></label>';
      // }
      return;
    },
    //disable editing on grid for specific rows which have isLocked == true
    onEditorPreparing(e) {
      if (e.parentType == "dataRow") {
        if (e.row.data.isLocked == true) {
          e.editorOptions.readOnly = true;
        }
      }
    },
    onRowValidating(e) {
      if (e.newData.HasAttended && e.oldData.AbsenceReasonId) {
        e.errorText = "Δεν μπορεί να έχει παρουσία με λόγο απουσίας";
        e.isValid = false;
      }

      if (
        e.newData.DisplayStartTime != null &&
        this.$moment(e.newData.DisplayStartTime).format("HH:mm") >
          this.$moment(e.oldData.DisplayEndTime).format("HH:mm") &&
        e.oldData.HasExited &&
        this.$moment(e.oldData.DisplayEndTime).format("HH:mm") != "00:00"
      ) {
        e.errorText =
          "Η ώρα εισόδου δεν μπορεί να είναι μεγαλύτερη της ώρας εξόδου";
        e.isValid = false;
      }

      if (
        e.newData.DisplayEndTime != null &&
        this.$moment(e.oldData.DisplayStartTime).format("HH:mm") >
          this.$moment(e.newData.DisplayEndTime).format("HH:mm")
      ) {
        e.errorText =
          "Η ώρα εισόδου δεν μπορεί να είναι μεγαλύτερη της ώρας εξόδου";
        e.isValid = false;
      }
    },

    //checks if attendance Record is locked
    attendanceRecordIsLocked(e) {
      return e.row.data.isLocked == true && this.showLock == true;
    },

    isAttendanceRecordValid(e) {
      return !e.row.data.IsValid;
    },

    isFromMobile(e) {
      return e.row.data.FromMobile;
    },

    //checks if attendance Record is unlocked
    attendanceRecordIsUnLocked(e) {
      return e.row.data.isLocked == false && this.showLock == true;
    },

    //checks if general lock must be applied
    checkServerLock() {
      if (this.remainingMinutesToLock == 0 || this.AttendanceIsLocked == true) {
        //time has passed so lock everything
        this.AttendanceIsLocked = true;
        this.lockAttendanceRecords();
      } else {
        this.AttendanceIsLocked = false;
        setTimeout(() => {
          this.AttendanceIsLocked = true; //wait for  this.remainingMinutesToLock min to lock
          this.lockAttendanceRecords();
        }, this.remainingMinutesToLock * 60 * 1000);
      }
    },

    showRecordLock(e) {
      debugger;
      return this.attendanceRecordIsLocked(e) && e.row.data.CanRecordBeUnLocked;
    },

    async setSelectedStructure(e) {
      if (e.value != null) {
        var _structure = this.getStructureInfo(e.value);
      } else {
        this.selectedStructureId = 0;
        this.attendanceRecords = [];
        return;
      }
      if (this.hasFullAccess) await this.getAttendanceRecords();
      else this.attendanceRecords = [];
    },

    async setSelectedDate(e) {
      this.date = this.$moment(e.value).format("MM/DD/YYYY");
      if (this.hasFullAccess) await this.getAttendanceRecords();
      else this.attendanceRecords = [];
    },

    async getStructures() {
      const res = await mainService.get(
        `/structures/GetStructuresByUserAndOrganization?organizationId=${this.organizationId}`
      );
      this.structures = res.data;
    },

    //locks all attendance records
    async lockAttendanceRecords() {
      this.attendanceRecords = this.attendanceRecords.map((item) => {
        item.isLocked = true;
        return item;
      });
      this.dataGrid
        .refresh()
        .then(function () {})
        .catch(function (error) {});
      if (this.attendanceRecordTimer != null) {
        clearTimeout(this.attendanceRecordTimer);
        this.attendanceRecordTimer = null;
      }
    },

    //unlocks all attendance records
    async unLockAttendanceRecords() {
      this.attendanceRecords = this.attendanceRecords.map((item) => {
        if (item.FromMobile == false) {
          item.isLocked = false;
        }
        return item;
      });
    },

    async getAttendanceRecords() {
      if (this.selectedStructureId != 0) {
        this.loadIndicatorVisible = true;
        const res = await mainService.get(
          `/attendances/GetAttendanceRecords?organizationId=${this.organizationId}&structureId=${this.selectedStructureId}&attendanceDate=${this.date}`
        );
        this.attendanceRecords = res.data.attendanceRecordDtos.map((item) => {
          item.isLocked = false; //this field is calculated and here takes its initial value false
          return item;
        });

        this.masterUnLockDisabled = this.attendanceRecords.some(
          (x) => !x.CanRecordBeUnLocked
        );

        this.showLock = res.data.ShowLock;
        this.remainingMinutesToLock = res.data.RemainingMinutesToLock;
        this.unlockDuration = res.data.UnlockDuration;
        this.AttendanceIsLocked = res.data.AttendanceIsLocked;
        if (res.data.attendanceRecordDtos.length > 0) {
          this.AttendanceStartTime =
            res.data.attendanceRecordDtos[0].AttendanceStartTime;
          this.AttendanceEndTime =
            res.data.attendanceRecordDtos[0].AttendanceEndTime;
        }

        this.checkServerLock();
        this.loadIndicatorVisible = false;
      }
    },
    async getAbsenceReasons() {
      const res = await mainService.get(`/AbsenceReasons/GetAllAbsenceReasons`);
      this.absenseReasons = res.data;
      this.absenseReasons.unshift({ Id: null, Description: "" });
    },
    async getUnlockReasons() {
      if (this.unlockReasons.length == 0) {
        const res = await mainService.get(`/UnlockReasons/GetAllUnlockReasons`);
        this.unlockReasons = res.data;
        this.unlockReasons.unshift({ Id: null, Description: "" });
      }
    },

    async onRowUpdating(e) {
      var attendanceRecord = Object.assign(e.oldData, e.newData);

      attendanceRecord.Id = e.key;

      await this.updateAttendanceRecord(attendanceRecord);

      if (
        e.newData.DisplayStartTime == e.data.DisplayStartTimeMobile &&
        e.data.DisplayStartTime != "0001-01-01T00:00:00"
      ) {
        e.rowElement[0].cells[3].style.backgroundColor = "#a2d4ab";
        e.rowElement[0].cells[4].style.backgroundColor = "#a2d4ab";
      }

      if (
        e.newData.DisplayEndTime == e.data.DisplayEndTimeMobile &&
        e.data.DisplayEndTime != "0001-01-01T00:00:00"
      ) {
        e.rowElement[0].cells[5].style.backgroundColor = "#a2d4ab";
        e.rowElement[0].cells[6].style.backgroundColor = "#a2d4ab";
      }

      if (this.attendanceRecordTimer == null) {
        this.attendanceRecordTimer = setTimeout(() => {
          this.lockAttendanceRecords();
        }, this.unlockDuration * 60 * 1000);
      }
    },

    async updateAttendanceRecord(attendanceRecord) {
      try {
        const res = await mainService.post(
          "/attendances/UpdateAttendanceRecord",
          attendanceRecord
        );

        if (res.status == 200 && res.data.Id == null) {
          notify(res.data, "error", 5000);
        } else {
          this.attendanceRecords = this.attendanceRecords.map((item) => {
            if (item.Id == res.data.Id) {
              item = res.data;
              item.isLocked = false;
            }
            return item;
          });

          notify("Η αποθήκευση πέτυχε", "success", 1000);
        }
      } catch (error) {
        console.log(error);
      }
    },

    async updateAttendance(attendance) {
      try {
        const res = await mainService.post(
          "/attendances/UpdateAttendanceRecordsByAttendance",
          attendance
        );
        await this.getAttendanceRecords();
        notify("Η αποθήκευση πέτυχε", "success", 1000);
      } catch (error) {
        console.log(error);
      }
    },
    //user press unlock on grid row
    async onUnlockAttendanceRecord(e) {
      this.selectedAttendanceId = 0;
      this.selectedAttendanceRecordId = e.row.data.Id;
      this.selectedUnlockReasonId = e.row.data.UnlockReasonId;

      await this.getUnlockReasons();

      this.unlockPopupIsVisible = true;
    },
    //user press unlock next to date field
    async onUnlockAttendance(e) {
      if (this.attendanceRecords.length > 0) {
        this.selectedAttendanceId = this.attendanceRecords[0].AttendanceId; //get the master record id of detail
        await this.getUnlockReasons();
        this.unlockPopupIsVisible = true;
      } else this.selectedAttendanceId = 0;
    },

    async onSaveFromPopup(e) {
      const temp = e;
      const temp2 = this;
      this.unlockPopupIsVisible = false;

      if (this.selectedAttendanceId != 0) {
        var attendance = {
          Id: this.selectedAttendanceId,
          UnlockReasonId: this.selectedUnlockReasonId,
          UnlockReasonDescription: this.selectedUnlockRasonDescription,
        };
        await this.updateAttendance(attendance);
        this.AttendanceIsLocked = false;
        this.unLockAttendanceRecords();

        if (this.attendanceRecordTimer == null) {
          this.attendanceRecordTimer = setTimeout(() => {
            this.lockAttendanceRecords();
            this.AttendanceIsLocked = true;
          }, this.unlockDuration * this.attendanceRecords.length * 60 * 1000);
        }
      } else if (this.selectedAttendanceRecordId != 0) {
        var attendanceRecord = this.attendanceRecords.find(
          (x) => x.Id == this.selectedAttendanceRecordId
        );
        attendanceRecord.UnlockReasonId = this.selectedUnlockReasonId;
        attendanceRecord.HasBeenUnlocked = true;
        attendanceRecord.UnlockReasonDescription =
          this.selectedUnlockRasonDescription;

        await this.updateAttendanceRecord(attendanceRecord);

        if (this.attendanceRecordTimer == null) {
          this.attendanceRecordTimer = setTimeout(() => {
            this.lockAttendanceRecords();
          }, this.unlockDuration * 60 * 1000);
        }
      }

      this.selectedAttendanceRecordId = 0;
      this.selectedAttendanceId = 0;
    },
    onCopyToClipboard(e) {
      debugger;
      const el = document.createElement("textarea");
      el.value = this.tempLink;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
      notify("Ο σύνδεσμος αντιγράφηκε επιτυχώς!", "success", 5000);
    },
    onClosePopup(e) {
      this.unlockPopupIsVisible = false;
      this.selectedAttendanceRecordId = 0;
      this.selectedAttendance = 0;
    },
    getStructureInfo(structureId) {
      return this.structures.filter((item) => item.Id == structureId);
    },
    async generateTempPrintLink() {
      var tempLink = await mainService.get(
        `attendances/CreateAttendancesListLink?attendanceDate=${this.date}&structureId=${this.selectedStructureId}`
      );

      this.tempLink = this.$ApiBaseUrl + tempLink.data;
      this.showTempLinkPopup = true;
    },
    onHiding() {
      this.showTempLinkPopup = false;
    },
  },
  created() {},
  async mounted() {
    this.date = this.$moment(this.dDate).format("MM/DD/YYYY");

    await this.getStructures();
    this.selectedStructureId = parseInt(this.sId);

    await this.getAbsenceReasons();
  },
  destroyed() {
    clearTimeout(this.attendanceRecordTimer);
    this.attendanceRecordTimer = null;
  },
};
</script>

<style>
</style>
